import { useEffect, useState } from "react";

export interface WindowSize {
    width: number;
    height: number;
}

const readWindowSize = (): WindowSize => ({
    width: window.innerWidth,
    height: window.innerHeight,
});

export const useWindowSize = (): WindowSize => {
    const [size, setSize] = useState(readWindowSize);

    useEffect(() => {
        const handleResize = () => {
            const next = readWindowSize();
            setSize(previous =>
                previous.width === next.width && previous.height === next.height
                    ? previous
                    : next,
            );
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return size;
};
